import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import * as R from 'ramda';
import { AppState } from '../../core/redux/appState';
import { RaterApprovalRater } from '../models';


const KEY_ACTION = ActionType.UpdateApprovedForAllRequest;
const ACTIONS    = [
  ActionType.UpdateApprovedForAllRequest,
  ActionType.UpdateApprovedForAllResponse,
  ActionType.UpdateApprovedForAllError,
];


type Payload = RaterApprovalRater[];


type Meta = {
  participantId: number;
  projectId: number
};


/**
 * Dispatch this action to change all unassigned raters for a recipient to approved
 *
 * @param participantId - database Id of the specific project participant for whom we wish to invite raters
 * @param projectId - database Id of the project to which we wish to invite raters
 * @param approverId - recipient Id
 */
export const approveAllRatersAction = (
  participantId: number,
  projectId: number,
  approverId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.UpdateApprovedForAll,
    headers:  { 'content-type': 'application/json' },
    body: (state: AppState) => JSON.stringify(
      {
        participantId,
        projectId,
        approverId,
      }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { participantId, projectId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${participantId}-${projectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const participantId = action.meta.participantId;
  const projectId     = action.meta.projectId;
  const metaTag       = `${participantId}-${projectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assocPath(['raterApprovalRaters', `${participantId}`, `${projectId}`], payload, successState);
};

export const updateApprovedForAllReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
